// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.feedback-jobs-modal[data-v-30464b54] {\n  padding: 20px 30px;\n}\n.feedback-jobs-modal__btn-wrapper[data-v-30464b54] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 20px -5px 0;\n}\n.feedback-jobs-modal__btn[data-v-30464b54] {\n  margin: 5px 0;\n}\n", ""]);
// Exports
module.exports = exports;
